import React from 'react';
import { SUPPORTED_LANGUAGES } from '../constants';
import { LanguageCode } from '../types';
import { useChatContext } from '../context/ChatContext';

export const LanguageSelector: React.FC = () => {
  const { dispatch } = useChatContext();

  const handleSelect = (code: LanguageCode) => {
    dispatch({ type: 'SET_LANGUAGE', payload: code });
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full max-w-lg">
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          onClick={() => handleSelect(lang.code as LanguageCode)}
          className="group flex flex-col items-center justify-center px-4 py-4 rounded-xl
                     border border-white/10 bg-neutral-900
                     hover:border-brand-500/60 hover:bg-brand-900/20
                     transition-all duration-200 shadow-sm cursor-pointer"
        >
          <span className="text-base font-bold text-white group-hover:text-brand-300 transition-colors">
            {lang.nativeName}
          </span>
          <span className="text-xs text-gray-500 mt-0.5">{lang.name}</span>
        </button>
      ))}
    </div>
  );
};
